//some utils goes here
// Converts image to canvas; returns new canvas element
import * as THREE from 'three';

export function getTextImage(text, image, pos) {
  var canvas = document.createElement("canvas");
  canvas.height = image.height;
  canvas.width = image.width;
  var ctx = canvas.getContext("2d");
  ctx.drawImage(image, 0, 0);
  ctx.font = "italic 20px 黑体";
  ctx.fillStyle = "White";
  ctx.translate(pos.width / 2, pos.height / 2); //先把画布中心移到中间	
  ctx.rotate(3 * Math.PI / 2); //注意这里是以原点为中心旋转
  ctx.fillText(text, -10, 15 - pos.width / 2, 200);
  return canvas;
}


export class Canvas2D {
  constructor(width, height) {
    this.width = width;
    this.height = height;
    this.canvas = document.createElement("canvas");
    this.canvas.width = this.width;
    this.canvas.height = this.height;
    this.scale = 1;
    this.ctx = this.canvas.getContext("2d");
    this.offsetX = 0;
    this.offsetY = 0;
  }

  //根据传入的宽和高计算应该scale的比例，在原有的width和height上的比例缩放到此canvas的比例
  autoScale(width, height) {
    var widthScale = this.width / width;
    var heightScale = this.height / height;
    this.scale = heightScale > widthScale ? widthScale : heightScale; //取较小的缩放比例以免溢出
    this.scale = 0.7 * this.scale;
  }

  setOffset(offsetX, offsetY) {
    this.offsetX = offsetX;
    this.offsetY = offsetY;
  }

  //为点执行位移
  translatePoint(orgPoint) {
    var point = new Object();
    point.x = orgPoint.x;
    point.y = orgPoint.y;
    //在原点缩放,并反向
    point.x = this.scale * (point.x - this.offsetX);
    point.y = (-1) * this.scale * (point.y - this.offsetY);
    //平移到画布中心,周边要留一些空隙
    point.x = point.x + this.width / 2;
    point.y = point.y + this.height / 2;
    return point;
  }

  drawCircle(pos, arcStyle){
    this.ctx.save();
    this.ctx.beginPath();
    this.ctx.arc(pos.x, pos.y, arcStyle.radius, 2*Math.PI, false);
    this.ctx.fillStyle=arcStyle.color;
    this.ctx.fill(); 
    this.ctx.restore();
  }

  drawLine(pointA, pointB, lineStyle, translate) {
	this.ctx.save(); 
     var ptA = pointA;
    var ptB = pointB; 
    //在原点缩放
    if (translate){
     ptA = this.translatePoint(pointA);
     ptB = this.translatePoint(pointB);  
    }
    
    if (lineStyle == null || lineStyle.color == undefined || lineStyle.color == null) lineStyle.color = '#000';
    if (lineStyle.dotted) {
      this.ctx.setLineDash([5, 3]);
    } else {
      this.ctx.setLineDash([5, 0]);
    }
    this.ctx.beginPath();
    this.ctx.strokeStyle = lineStyle.color; //设置线的颜色状态
    this.ctx.fillStyle = lineStyle.color;
    this.ctx.moveTo(ptA.x, ptA.y);
    this.ctx.lineTo(ptB.x, ptB.y);
    this.ctx.stroke();
    this.ctx.restore();
  }

  drawTrangleMark(point, height, text, style) {
	this.ctx.save();

    //先在原始坐标计算各点位置，然后在位移后的位置画出三角形,三角形尖角应朝上
    var ptB = this.translatePoint(point, 1);
    var ptL = { 'x': ptB.x - height / 2, 'y': ptB.y - height };
    var ptR = { 'x': ptB.x + height / 2, 'y': ptB.y - height };

    if (style == null || style.color == undefined || style.color == null) style.color = '#000';
    if (style.dotted) {
      this.ctx.setLineDash([5, 3]);
    } else {
      this.ctx.setLineDash([5, 0]);
    }

    this.ctx.beginPath();
    this.ctx.strokeStyle = style.color; //设置线的颜色状态
    this.ctx.fillStyle = style.color;
    this.ctx.moveTo(ptB.x, ptB.y);
    this.ctx.lineTo(ptL.x, ptL.y);
    this.ctx.moveTo(ptL.x, ptL.y);
    this.ctx.lineTo(ptR.x, ptR.y);
    this.ctx.moveTo(ptR.x, ptR.y);
    this.ctx.lineTo(ptB.x, ptB.y);
    this.ctx.stroke();
    if (text != undefined && text != null) {
      this.ctx.font = "normal 10px 黑体";
      if (style.markabove) {
        this.ctx.fillText(text, ptB.x - 20, ptB.y - height - 3, 50);
      }

    }

    this.ctx.restore(); //重要，否则ctx会影响之前的设置一起变
  }

  drawArrow(ctx,fromX, fromY, toX, toY, theta, headlen, width, color) {
    theta = typeof(theta) != 'undefined' ? theta : 30;
    headlen = typeof(theta) != 'undefined' ? headlen : 10;
    width = typeof(width) != 'undefined' ? width : 1;
    color = typeof(color) != 'color' ? color : '#000';
    var angle = Math.atan2(fromY - toY, fromX - toX) * 180 / Math.PI,
      angle1 = (angle + theta) * Math.PI / 180,
      angle2 = (angle - theta) * Math.PI / 180,
      topX = headlen * Math.cos(angle1),
      topY = headlen * Math.sin(angle1),
      botX = headlen * Math.cos(angle2),
      botY = headlen * Math.sin(angle2);
    
    ctx.beginPath();
    var arrowX = fromX - topX,
      arrowY = fromY - topY;
    ctx.moveTo(arrowX, arrowY);
    ctx.moveTo(fromX, fromY);
    ctx.lineTo(toX, toY);
    arrowX = toX + topX;
    arrowY = toY + topY;
    ctx.moveTo(arrowX, arrowY);
    ctx.lineTo(toX, toY);
    arrowX = toX + botX;
    arrowY = toY + botY;
    ctx.lineTo(arrowX, arrowY);
    ctx.strokeStyle = color;
    ctx.lineWidth = width;
    ctx.stroke();
   
  }

  drawLengthMark(pointA, pointB, markVal) {
    this.ctx.save();
    var ptA = this.translatePoint(pointA);
    var ptB = this.translatePoint(pointB);

    //画竖线
    this.ctx.beginPath();
    this.ctx.moveTo(ptA.x, ptA.y + 5);
    this.ctx.lineTo(ptA.x, ptA.y + 20);

    this.ctx.moveTo(ptB.x, ptB.y + 5);
    this.ctx.lineTo(ptB.x, ptB.y + 20);
    this.ctx.stroke();
    //画箭头
	this.drawArrow(this.ctx, ptA.x, ptA.y + 12.5, ptB.x, ptB.y + 12.5, 30,5,1);
	this.drawArrow(this.ctx, ptB.x, ptB.y + 12.5, ptA.x, ptA.y + 12.5, 30,5,1);
	//画文字
	this.ctx.font = "normal 10px 黑体";
	var txtSize = this.ctx.measureText(markVal);
	var txtStart = ptA.x + (ptB.x - ptA.x -  txtSize.width) / 2;
	this.ctx.rect(txtStart - 5, ptA.y + 10, txtSize.width + 10, 10);
	this.ctx.fillStyle='#fff';
	this.ctx.fill(); 
	this.ctx.fillStyle = '#000';
	this.ctx.fillText(markVal, txtStart, ptA.y +15, 50);

    this.ctx.restore(); //重要，否则ctx会影响之前的设置一起变
  }

  get() {
    return this.canvas;
  }

}

export class SelectableObject {
  constructor(material) {
    this.material = material;
  }

  select() {
    this.material.color.setHex(0xff0000);
  }

  deselect() {
    this.material.color.setHex(0xffffff);
  }
}

export function getVectorContainers(sourcePts, containerStationPts){
    //通过计算源向量和容器向量首尾的差，如果和头向量的差与尾向量的差的点乘<0（不需要考虑y轴路面高度轴）,则认为在两向量之间。加入到头向量的容器集合中。
    //两数组均排序，故正向遍历即可
    var containerCounter = 0;
    sourcePts.map(item=>{
      var containerStart = containerStationPts[containerCounter];
      var containerEnd = containerStationPts[containerCounter + 1];
      var vec1 = new THREE.Vector2(item.x - containerStart.x, item.z - containerStart.z);
      var vec2 = new THREE.Vector2(containerEnd.x - item.x, containerEnd.z - item.z);
      if(vec1.dot(vec2) >= 0) {
        item.stake = containerStart.stake;
        item.roadUnit = containerStart.roadUnit;
      }
      else{
        item.stake = containerEnd.stake;
        item.roadUnit = containerEnd.roadUnit;
        containerCounter++;
      }
    });
    return sourcePts;
}




// WEBPACK FOOTER //
// ./src/plugins/js/util.js